<template>
    <pendo-tag
        class="upsell-tag"
        round
        subtle
        :prefix-icon="{
            type: 'arrow-up',
            strokeWidth: '2.5',
            size: '14',
        }"
        :style="{
            'backgroundColor': 'transparent',
            'border-color': 'var(--palette-gray-40)',
            'color': 'var(--palette-gray-80)',
            'font-weight': '600',
            'padding': '0',
            'border-radius': '50%',
            'height': '20px',
            'width': '20px',
        }" />
</template>

<script>
import { PendoTag } from '@pendo/components-vue3';

export default {
    name: 'UpsellTag',
    components: {
        PendoTag,
    },
};
</script>

<style lang="less" scoped>
:deep(.pendo-tag__prefix-icon) {
    margin-right: 0;
}
</style>
